import React, { useEffect, useState } from "react";
import { useGlobalContext } from "../../../../context/global/state";
import AccountPlanHeader from "./accountPlanHeader/accountPlanHeader";
import SecondaryNav from "./secondaryNav/secondaryNav";

const SecondaryMenuController: React.FC = () => {
	const [refComponent, setRefComponent] = useState<any>(null);
	const { state, dispatch } = useGlobalContext();
	const ref = React.createRef<HTMLDivElement>();

	// Save ref to global state
	useEffect(() => {
		if (ref.current) {
			if (!state.secondaryNav) {
				setRefComponent(ref.current);
				dispatch({ type: "secondaryNav", payload: ref.current });
			}
		}
	}, [ref, state.secondaryNav, refComponent, dispatch]);

	const wrapperProps = {
		ref,
		role: "navigation",
		// className: `${otherExperience && "hideSection"}`, // TODO: add context so only one listener (take listener from accountPlanHeader)
	};

	return (
		<div {...wrapperProps} aria-label="Secondary navigation">
			<AccountPlanHeader />
			<SecondaryNav />
		</div>
	);
};

export default SecondaryMenuController;
